import merge from 'lodash/merge';
import * as types from '../constants/action-types';

const initialState = {
  showStepNav: false,
  stepName: null,
  messageCount: null,
  managedAccount: null,
  width: 0
};

export default function nav (state = initialState, action) {
  switch (action.type) {
  case types.MESSAGE_COUNT_SUCCESS: {
    const { messageCount } = action;

    return merge({}, state, {
      messageCount
    });
  }

  case types.MANAGED_ACCOUNT_SUCCESS: {
    const { managedAccount } = action;

    return merge({}, state, {
      isFetching: false,
      hasFetched: true,
      managedAccount
    });
  }

  case types.SET_NAV_STEP: {
    const { stepName, progressBarWidth } = action;

    return merge({}, state, {
      showStepNav: true,
      stepName,
      progressBarWidth
    });
  }

  case types.CLEAR_NAV_STEP: {
    return merge({}, state, {
      showStepNav: false,
      stepName: null
    });
  }

  default:
    return state;
  }
}
